export interface DismissibleNotification {
  dismissed?: boolean;
}

const MAX_NOTIFICATION_HISTORY_SCAN = 5_120;

export function visibleNotificationWindow<T extends DismissibleNotification>(
  notifications: readonly T[],
  max: number
): T[] {
  return notifications.filter((notification) => notification.dismissed !== true).slice(0, max);
}

/**
 * Dismissed cards remain as durable delivery markers. Expand the newest-first
 * query until it contains the requested number of visible cards or exhausts
 * the user's history, so archived rows do not crowd active rows out.
 */
export function nextNotificationHistoryLimit(
  received: number,
  visible: number,
  currentLimit: number,
  desiredVisible: number
): number | null {
  if (visible >= desiredVisible || received < currentLimit) return null;
  const next = Math.min(
    MAX_NOTIFICATION_HISTORY_SCAN,
    Math.max(currentLimit * 2, currentLimit + desiredVisible)
  );
  return next > currentLimit ? next : null;
}
